export interface PasswordChecks {
  length: boolean;
  lowercase: boolean;
  uppercase: boolean;
  number: boolean;
}

export function getPasswordChecks(pw: string): PasswordChecks {
  const p = pw || '';
  return {
    length: p.length >= 8,
    lowercase: /[a-z]/.test(p),
    uppercase: /[A-Z]/.test(p),
    number: /[0-9]/.test(p),
  };
}

export function validatePassword(pw: string): { valid: boolean; message?: string } {
  const c = getPasswordChecks(pw);
  const valid = c.length && c.lowercase && c.uppercase && c.number;
  return valid
    ? { valid: true }
    : { valid: false, message: 'At least 8 characters, with 1 each of lowercase, uppercase & numbers.' };
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
}
